import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Analysis(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Analysis", children: [
    /* @__PURE__ */ jsx("path", { d: "M6.74805 4.4082h4.55735v2.48522H6.74805V4.4082Z", fill: theme.vars.palette.primary.dark }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M6.70117 9.14551H18.1346v2.48519H6.70117V9.14551Zm0 4.73739h9.21013v2.4852H6.70117v-2.4852Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M6.70117 38.4065v-4.2609c.00003-.1855.07375-.3634.20496-.4946.13121-.1312.30915-.2049.4947-.2049h3.54347c.1855 0 .3635.0737.4947.2049.1312.1312.2049.3091.2049.4946v4.2609H6.70117Zm9.88523 0V28.0072c0-.0919.0181-.1829.0532-.2678.0352-.0848.0867-.162.1517-.2269.065-.065.1421-.1165.227-.1517.0849-.0351.1758-.0532.2677-.0532h3.5434c.0919 0 .1828.0181.2677.0532.0849.0352.162.0867.227.1517.065.0649.1165.1421.1517.2269.0351.0849.0532.1759.0532.2678v10.3993h-4.9426Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M26.4707 38.4065V18.1551c0-.0918.0181-.1828.0532-.2677.0352-.0848.0867-.162.1516-.2269.065-.065.1421-.1165.227-.1517.0848-.0351.1758-.0532.2677-.0532h3.5434c.1856 0 .3635.0737.4947.2049.1312.1311.205.3091.205.4946v20.2514h-4.9426Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M36.3572 38.4064V5.10743c.0001-.18554.0738-.36348.205-.49467.1312-.13119.3091-.20489.4947-.20489h3.5435c.0918 0 .1828.01809.2677.05325.0848.03516.1619.08669.2269.15165.0649.06496.1165.14208.1516.22696.0352.08487.0532.17584.0532.2677V38.4063h-4.9426v.0001Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M6.70117 40.999H41.2993v2.593H6.70117v-2.593Z", fill: theme.vars.palette.secondary.main })
  ] });
}
Analysis.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Analysis"
};
validateTidalLicense();
export {
  Analysis
};
//# sourceMappingURL=Analysis.js.map
